
import { getCustomTypeFromUrl, getAllUrls } from './utils'
import { CUSTOM_TYPES } from '@/app/prismic/link-resolver'

export default {
  name: 'BreadcrumbsStateless',
  props: {
    type: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      customTypes: CUSTOM_TYPES,
    }
  },
  computed: {
    currentCustomType() {
      return this.customTypes[this.type]
    },
    links() {
      if (!this.currentCustomType) {
        return []
      }
      return getAllUrls(this.currentCustomType.url).map((url) => {
        const customType = getCustomTypeFromUrl(url, this.customTypes)
        return this.customTypes[customType]
      })
    },
    shouldShowBreadcrumbs() {
      return this.links.length > 1
    },
  },
}
